import styled from 'styled-components';
import TaskContainer from '../TaskContainer/TaskContainer';

export const StyledSubTaskContainer = styled(TaskContainer)`
  float: right;
`;
